export const getDefaultLanguage = (langSelect) => {
  switch (langSelect) {
    case "de-AT":
      return "at";
    case "at":
      return "at";
    case "en":
      return "en";

    default:
      return "da";
  }
};

export const getAppTitle = (stateLang) => {
  switch (stateLang) {
    case "de-AT":
    case "de":
    case "at":
      return "Datenschutzhinweis";
    case "da":
      return "Databeskyttelsesmeddelelse";
    case "en":
      return "Privacy policy";

    default:
      break;
  }
};
